import { useMemo, useState } from 'react';

export const useRjActivity = (allEmployees, allSchedules, allHours, allUnclosed) => {
  const [activity, setActivity] = useState('active');
  const filtered = useMemo(() => {
    const users = new Map(allEmployees.map(u => [u.user_id, u]));
    const matches = (row) => {
      if (activity === 'all') return true;
      const user = users.get(row.user_id);
      if (!user) return false;
      return activity === 'inactive' ? user.active === false : user.active !== false;
    };
    return {
      employees: allEmployees.filter(matches), schedules: allSchedules.filter(matches),
      hoursSchedules: allHours.filter(matches), unclosedMissions: allUnclosed.filter(matches),
    };
  }, [activity, allEmployees, allSchedules, allHours, allUnclosed]);
  return { ...filtered, activity, setActivity };
};

export const RjActivityFilter = ({ activity, setActivity, prefix }) => <label className="flex flex-wrap items-center gap-2 text-sm font-medium">
  Salariés
  <select className="h-9 border rounded-md px-2 bg-white" value={activity} onChange={e => setActivity(e.target.value)} data-testid={`${prefix}-rj-activity-filter`}>
    <option value="active">Actifs</option><option value="inactive">Désactivés</option><option value="all">Tous</option>
  </select>
</label>;